import React from "react";
import { Globe, Building2 } from "lucide-react";

/** Global defaults | one client (admins edit a client's set on their behalf). */
export function ScopePicker({ clients, value, onChange, set }) {
    return (
        <div className="flex flex-wrap items-center gap-3" data-testid="va-scope">
            <label className="text-xs text-slate-400 inline-flex items-center gap-2">
                {value ? <Building2 className="w-4 h-4 text-sky-300" /> : <Globe className="w-4 h-4 text-emerald-300" />}
                Editing
                <select value={value} onChange={(e) => onChange(e.target.value)} className="rounded bg-slate-950/60 border border-slate-700 px-2 py-1.5 text-sm text-slate-100 min-w-[260px]" data-testid="va-scope-select">
                    <option value="">Global defaults (every client inherits)</option>
                    {(clients || []).map((c) => (
                        <option key={c.client_id} value={c.client_id}>{c.name}{c.has_set ? ` · v${c.version}${c.has_weights ? " · weights" : ""}` : " · inherits global"}</option>
                    ))}
                </select>
            </label>
            {set ? (
                <span className="text-xs text-slate-500" data-testid="va-version">
                    {set.scope === "global" ? "global set" : `tenant ${set.client_id}`} · v{set.version}
                    {set.inherits ? ` · inherits global v${set.inherits.version}` : ""}
                    {set.updated_at ? ` · ${set.updated_by}` : " · untouched"}
                </span>
            ) : null}
        </div>
    );
}
